module.exports = __webpack_public_path__ + "img/icon-unlock.c5b9326b.svg";